<template>
  <div :key="componentKey">
  <div v-if="isOpenProva">
    <div>
      <p>Prova Teórica</p>
      <iframe
        id="Provas"
        :src="linkProva"
        width="100%"
        height="600px!important"
      />
      <v-btn color="primary" block @click="closeProva">
        Sair
      </v-btn>
    </div>
  </div>

  <div v-else-if="live">
    <div v-if="showModal && disableInteraction == true" class="overlay" @touchmove.prevent @touchstart.prevent></div>
    <v-dialog v-if="showModal" v-model="showModal" max-width="600" max-height="200">
      <coleta-biometria :tempObjMeet="tempObjMeet" :choosedGesture="choosedGesture" :momento-atual="momento" />
    </v-dialog>
    <LiveChat
      :linkMeet="linkMeet"
      :tempObjMeet="tempObjMeet"
      :domain="jitsiDomain"
      :jitsiExternalScript="jitsiExternalScript"
      :jwt="jitsiJWT"
      @apiMeetInitialized="handleApiMeetInitialized"
      @agendar-intervalo="agendarIntervaloCapturaAleatoria" 
    />
    <v-btn
      color="red"
      style="
        z-index: 110;
        color: #fff"
      block
      @click="closeLive"
    >
      <v-icon style="transform: rotate(134deg); margin-right: 10px">
        phone
      </v-icon>
      Sair
    </v-btn>
  </div>

  <div v-else>
    <div v-if="showModal && disableInteraction == true" class="overlay" @touchmove.prevent @touchstart.prevent></div>
    <v-dialog v-if="showModal" v-model="showModal" max-width="600" max-height="200">
      <coleta-biometria :tempObjMeet="tempObjMeet" :choosedGesture="choosedGesture" :momento-atual="momento" />
    </v-dialog>

    <v-card style="background: aliceblue">
      <v-dialog v-if="showModalCheck" v-model="showModalCheck" max-width="800">
        <CheckList style="padding: 0;" />
      </v-dialog>
    </v-card>
    <div v-if="!permissaoBiometria">
    <v-checkbox
      v-model="imagePermission"
      label="Permitir coleta de imagem para a aula"
      @change="handlePermissionChange"
    ></v-checkbox>
   </div>
    <v-btn
      fab
      fixed
      right
      bottom
      style="bottom: 8.5%; right: 4.5%"
      color="blue lighten-1"
      :loading="loading"
      @click="update"
    >
      <v-icon
        color="white"
      >
        update
      </v-icon>
    </v-btn>
    <label> Filtrar aulas por status: </label>
    <v-select
      v-model="selectedStatus"
      item-text="value"
      :items="status"
      type="number"
      label=""
      chips
      multiple
      dense
    >
      <template #selection="{ item }">
        <v-chip :color="getColor(item.status)" text-color="white">
          {{ item.value }}
        </v-chip>
      </template>
    </v-select>
    <v-data-table
      :items-per-page="20"
      :loading="loading"
      :headers="headers"
      :items="agendaAulas"
      :search="search"
      style="box-shadow: none;"
    >
      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="getColor(item.status)" dark>
          {{ getStatus(item.status) }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-chip
          color="green" dark
          :disabled="((item.status != '5' && item.status != '4' && item.status != '8') || closedAula == true) && !isCurrentClass(item.id)"
          @click="showImageModal(item)"
        >
          Entrar
        </v-chip>
      </template>
      <template v-slot:[`item.provas`]="{ item }">
        <v-icon
          small
          color="teal"
          :disabled="(item.status !== '5' || !isProva(item.link_meet) || isBlocked(item))"
          @click="openProva(item.link_meet)"
        >
          mdi-file-document
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary">
          Sem Aulas
        </v-btn>
      </template>
    </v-data-table>
   </div>
  </div>
</template>

<script>
import LiveChat from "./LiveChat";
import aulaTeorico from "../../ws/aulasTeorica";
import CheckList from '../CheckList/CheckList';
import ColetaBiometria from "@/components/Teorico/coletaBiometria";
import aluno from "@/ws/aluno";
import Api from "@/service/Api";
import { th } from "date-fns/locale";

export default
{
  components:
    {
      ColetaBiometria,
      LiveChat,
      CheckList
    },
  watch: {
    '$route.path'(newPath) {
      if (window.location.hash.includes('#aula')) {
        this.startTracking();
      }
    },
    '$route.hash'(newHash) {
      if (newHash.includes('#aula')) {
        this.startTracking();
      }
    }
  },
  data()
  {
    return {
      componentKey: 0,
      isTrackingActive: false,
      visibilityCheckInterval: null,
      lastVisibilityState: document.hidden,
      previousRoute: this.$route.path,
      deviceType: null,
      browserInfo: null,
      statusCheckInterval: null,
      MOMENTO_INICIAL: 0,
      MOMENTO_ALEATORIO: 1,
      MOMENTO_FINAL: 2,
      randomImageTake: false,
      currentTime: 0,
      tempObjMeet: null,
      classId: null,
      studentId: null,
      live: false,
      closedAula: false,
      randomPhoto: false,
      isOpenProva: false,
      showModal: false,
      showModalCheck: false,
      classStart: true,
      choosedGesture: null,
      currentClass: null,
      loading: true,
      hasBioReturn: false,
      selectedStatus: false,
      imagePermission: false,
      permissaoBiometria: false,
      disableInteraction: false,
      captureTimeouts: [],
      status: [
        { status: 1, value: this.getStatus(1) },
        { status: 5, value: this.getStatus(5) },
        { status: 6, value: this.getStatus(6) },
        { status: 7, value: this.getStatus(7) },
        { status: 3, value: this.getStatus(3) },
        { status: 2, value: this.getStatus(2) },
        { status: 4, value: this.getStatus(4) },
      ],

      gestures: [
        { name: "Mostre um dedo com a sua mão esquerda", key: "one_finger" },
        { name: "Mostre dois dedos com a sua mão esquerda", key: "two_finger" },
        {
          name: "Mostre três dedos com a sua mão esquerda",
          key: "three_finger"
        },
        {
          name: "Mostre quatro dedos com a sua mão esquerda",
          key: "four_finger"
        },
        {
          name: "Mostre cinco dedos com a sua mão esquerda",
          key: "five_finger"
        }
      ],
      headers: [
        {
          text: "#ID",
          align: "start",
          sortable: false,
          value: "id"
        },
        { text: "Instrutor", value: "instrutor" },
        { text: "Sala", value: "sala" },
        { text: "Turma", value: "turma" },
        { text: "Data Hora", value: "data_hora" },
        { text: "Duração", value: "duracao" },
        {
          text: "Status",
          value: "status",
          filter: (value) => {
            if(this.selectedStatus == false) return true
            return this.selectedStatus.includes(this.getStatus(value));
          }
        },
        { text: "Prova Online",value: "provas", sortable: false},
        { text: "Aula Online", value: "actions", sortable: false },
      ],
      agendaAulas: [],
      linkMeet: "",
      jitsiDomain:"",
      jitsiExternalScript:"",
      jitsiJWT:"",
      randomImage: null,
      linkProva: null,
    };
  },
  created()
  {
    this.getAulaTeorico();
    this.selectedStatus = ["SALA ABERTA", "EM ANDAMENTO", "INTERVALO"];
    this.checkPermissaoBiometria();
    this.startStatusCheckInterval();
  },

  mounted()
  {
    this.getCurrentClass();
    this.detectDevice();

    document.addEventListener('carregaInicio', () => {
      this.abrirModalBiometria(this.MOMENTO_INICIAL);
    });

    document.addEventListener('carregaModal', () => {
      this.capturarFotoAleatoria(this.MOMENTO_ALEATORIO);
    });

    document.addEventListener('closeBio', () => {
      this.fecharModalBiometria();
    });

    document.addEventListener('toLiveStream', () => {
      this.showModal = false;
      this.toLiveStream();
      this.$router.push({ hash: '#aula' });
      
    });
    this.startTracking();
  },

  methods:
    {
      refreshComponent() {
        this.$router.push({ hash: '#aula' });
        // Força a atualização do componente
        this.componentKey += 1;
        console.log("Componente atualizado com a chave:", this.componentKey);
        this.scheduleNextCheck();
        
        this.$nextTick(() => {
          if (!window.location.hash.includes('#aula')) {
            this.$router.push({ hash: '#aula' });
          }
        });
      },
      convertMTToLocalTime(mtTimeString) {
       
        const [hours, minutes, seconds] = mtTimeString.split(':');
        const mtDate = new Date();
        mtDate.setUTCHours(parseInt(hours) + 4, parseInt(minutes), parseInt(seconds));

        const localDate = new Date(mtDate.toISOString());

        return localDate;
      },
      scheduleRandomCaptures(horariosEpoch) {
        if (this.captureTimeouts) {
          this.captureTimeouts.forEach(timeout => clearTimeout(timeout));
          this.captureTimeouts = [];
        }

        const nowEpoch = Date.now();

        console.log(`Timestamp local atual: ${nowEpoch}. Agendando capturas...`);
        if (!horariosEpoch || horariosEpoch.length === 0) {
          console.warn("Nenhum horário de captura foi recebido para agendamento.");
          return;
        }

        horariosEpoch.forEach(captureEpoch => {
          const delay = captureEpoch - nowEpoch;
          if (delay > 0) {
            const captureDate = new Date(captureEpoch);
            console.log(`Captura agendada para ${captureDate.toLocaleTimeString()} (horário local). O disparo ocorrerá em ${Math.round(delay / 1000)} segundos.`);

            const timeout = setTimeout(() => {
              if (this.tempObjMeet && this.tempObjMeet.status !== '8') {
                console.log(`Disparando captura agendada para o timestamp ${captureEpoch}`);
                this.capturarFotoAleatoria(this.MOMENTO_ALEATORIO);
              } else {
                console.log("Captura cancelada - aula em intervalo");
              }
            }, delay);

            this.captureTimeouts.push(timeout);
          } else {
            const captureDate = new Date(captureEpoch);
            console.log(`O horário de captura ${captureDate.toLocaleTimeString()} (timestamp ${captureEpoch}) já passou. Ignorando.`);
          }
        });
      },

      startTracking() {
        // Inicia o rastreamento de visibilidade
        const handleVisibilityChange = () => {
          const isHidden = document.hidden;
          const action = isHidden ? 'saiu_da_aba' : 'voltou_para_aba';

            if (this.lastVisibilityState !== isHidden) {
              if (!window.location.hash.includes('#aula') && this.$route.path !== this.previousRoute) {
                this.logVisibilityAction(`saiu_da_aula_para_${this.$route.path}`);
                this.previousRoute = this.$route.path;
                return;
              }
              if (!window.location.hash.includes('#aula')) return;
              this.logVisibilityAction(action);
              this.lastVisibilityState = isHidden;
            }
          };

          document.addEventListener('visibilitychange', handleVisibilityChange);
          this.isTrackingActive = true;
          this.visibilityChangeListener = handleVisibilityChange;

          console.log("Rastreamento iniciado com tempObjMeet:", this.tempObjMeet);
     },

      stopTracking() {
          if (this.visibilityChangeListener) {
              document.removeEventListener('visibilitychange', this.visibilityChangeListener);
              this.visibilityChangeListener = null;
          }
          this.isTrackingActive = false;
      },

       handleApiMeetInitialized(apiMeet) {
        this.apiMeet = apiMeet; // Armazena a referência da API
        console.log("API do Jitsi Meet inicializada:", this.apiMeet);
       },

      detectDevice() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
          
        if (/android/i.test(userAgent)) {
           this.deviceType = "Android";
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          this.deviceType = "iOS";
        } else {
          this.deviceType = "Desktop";
        }
          
        this.browserInfo = this.getBrowserInfo();
      },

      getBrowserInfo() {
        const userAgent = navigator.userAgent;
        if (userAgent.includes("Firefox")) return "Firefox";
        if (userAgent.includes("SamsungBrowser")) return "Samsung Browser";
        if (userAgent.includes("Opera") || userAgent.includes("OPR")) return "Opera";
        if (userAgent.includes("Trident")) return "Internet Explorer";
        if (userAgent.includes("Edge")) return "Edge";
        if (userAgent.includes("Chrome")) return "Chrome";
        if (userAgent.includes("Safari")) return "Safari";
        return "Desconhecido";
      },
      getOSVersion() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        
        // Windows
        if (/windows nt/i.test(userAgent)) {
          if (/Windows NT 10.0/i.test(userAgent)) return "Windows 10 ou 11";
          if (/Windows NT 6.3/i.test(userAgent)) return "Windows 8.1";
          if (/Windows NT 6.2/i.test(userAgent)) return "Windows 8";
          if (/Windows NT 6.1/i.test(userAgent)) return "Windows 7";
          return "Windows";
        }
        
        // Mac
        if (/macintosh|mac os x/i.test(userAgent)) {
          if (/Mac OS X 10_15/i.test(userAgent)) return "macOS Catalina (10.15)";
          if (/Mac OS X 10_14/i.test(userAgent)) return "macOS Mojave (10.14)";
          if (/Mac OS X 10_13/i.test(userAgent)) return "macOS High Sierra (10.13)";
          if (/Mac OS X 10_12/i.test(userAgent)) return "macOS Sierra (10.12)";
          if (/Mac OS X 10_11/i.test(userAgent)) return "macOS El Capitan (10.11)";
          if (/Mac OS X 10_10/i.test(userAgent)) return "macOS Yosemite (10.10)";
          return "macOS";
        }
        
        // Android
        if (/android/i.test(userAgent)) {
          const androidVersion = userAgent.match(/Android\s([0-9.]+)/);
          return androidVersion && androidVersion[1] ? androidVersion[1] : "Android";
        }
        
        // iOS
        if (/iPad|iPhone|iPod/i.test(userAgent)) {
          if (/OS 17_/.test(userAgent)) return "iOS 17";
          if (/OS 16_/.test(userAgent)) return "iOS 16";
          if (/OS 15_/.test(userAgent)) return "iOS 15";
          if (/OS 14_/.test(userAgent)) return "iOS 14";
          if (/OS 13_/.test(userAgent)) return "iOS 13";
          if (/OS 12_/.test(userAgent)) return "iOS 12";
          if (/OS 11_/.test(userAgent)) return "iOS 11";
          if (/OS 10_/.test(userAgent)) return "iOS 10";
          if (/OS 8_/.test(userAgent)) return "iOS 8";
          if (/OS 7_/.test(userAgent)) return "iOS 7";
          if (/OS 6_/.test(userAgent)) return "iOS 6";
          return "iOS";
        }
        
        // Linux
        if (/linux/i.test(userAgent)) return "Linux";
        
        return "Desconhecido";
      },

      async logVisibilityAction(action) {
        const currentTimestamp = new Date().toISOString();
        try {
          await Api.post(`/aulasteorica/salvarLog/${this.tempObjMeet.id}/${this.$store.getters.getAluno.id}`, {
            eventos: action,
            navegador: this.browserInfo,
            dispositivo: this.deviceType,
            versao_dispositivo: this.getOSVersion(),
            timestamp: currentTimestamp,
          });
          console.log("Log registrado com sucesso:", action);
        } catch (error) {
          console.error('Erro ao registrar:', error);
        }
      },

      beforeDestroy() {
        clearInterval(this.statusCheckInterval);
        if (this.captureTimeouts) {
          this.captureTimeouts.forEach(timeout => clearTimeout(timeout));
          this.captureTimeouts = [];
        }
      },
      isProva(url)
      {
        if(url != null) {
          if((url.match("docs.google") != null)||(url.match("forms.gle") != null)) {
            return true;
          }
        }
        return false;
      },

      openProva(url)
      {
        this.linkProva = url;
        this.isOpenProva = !this.isOpenProva;
      },

      closeProva()
      {
        this.isOpenProva = !this.isOpenProva;
      },

      isBlocked(item)
      {
        if((item.status != '4' && item.status != '5' && item.status != '8') && this.closedAula == true) {
          return true;
        }

        return false;
      },

      async getCurrentClass()
      {
        var response = "";
        try {
          response = await aluno.getLastClass(this.$store.getters.getAluno.cpf);
          if (response.data.last_class_id){
            this.currentClass = response.data.last_class_id;
            return response.data.last_class_id;
          }
        } catch (e) {
          console.log(e);
        }
        return false;
      },

      isCurrentClass(id)
      {
        return this.currentClass === id;
      },

      getColor(status)
      {
        if (status == 4) return "red";
        else if (status == 1) return "blue";
        else if (status == 2) return "green";
        else if (status == 5) return "orange";
        else if (status == 8) return "purple";
        else return "red";
      },

      getStatus(status)
      {
        if (status == "4") return "EM ANDAMENTO";
        else if (status == "1") return "AGENDADA";
        else if (status == "2") return "AULA FINALIZADA";
        else if (status == "3") return "CANCELADA";
        else if (status == "5") return "SALA ABERTA";
        else if (status == "6") return "SALA FECHADA";
        else if (status == "7") return "SALA INDISPONÍVEL";
        else if (status == "8") return "INTERVALO";

        else return "DESCONHECIDO";
      },
      async checkAulaStatus() {
        this.startStatusCheckInterval();
        try {
            const response = await Api.get(`/aulasteorica/getStatusAula/${this.tempObjMeet.id}`);
            const novoStatus = response.data.status;
            if (novoStatus == 8) {
              this.$emit('cancelar-capturas');
            }
            if (novoStatus !== this.tempObjMeet.status) {
              this.tempObjMeet.status = novoStatus;
              if (novoStatus == 4) {
                this.agendarIntervaloCapturaAleatoria();
                this.tempObjMeet.status = novoStatus;
                this.$emit('programar-bio-aleatoria');
               }
            } 
        } catch (error) {
          console.log("Erro ao checar o status: ", error);
        }
      },

      async agendarIntervaloCapturaAleatoria() {
        try {
          await Api.get(`/aulasteorica/agendarCapturasAleatorias/${this.tempObjMeet.id}/${this.$store.getters.getAluno.id}`);
          const responseEpoch = await Api.get(`/aulasteorica/${this.tempObjMeet.id}/${this.$store.getters.getAluno.id}/horarios`);
          const horariosEpoch = responseEpoch.data.horarios_epoch_ms;
          this.scheduleRandomCaptures(horariosEpoch);

        } catch (error) {
          console.error('Ocorreu um erro durante o processo de agendamento de capturas:', error);
        }
      },

      startStatusCheckInterval() {
        let lastScheduledMinute = null;

        const getRandomInterval = () => {
          let interval;
          let nextMinute;

        do {
            interval = Math.floor(Math.random() * (60000 - 10000 + 1)) + 10000; // Random entre 10s e 60s
            const nextDate = new Date(Date.now() + interval);
            nextMinute = nextDate.getMinutes();
        } while (
            nextMinute === lastScheduledMinute // Mesmo minuto
        );

        lastScheduledMinute = nextMinute; 
        return interval;
    };

    const scheduleNextCheck = () => {
        const interval = getRandomInterval();
        const nextCheckTime = new Date(Date.now() + interval).toLocaleTimeString(); 
        console.log(`Intervalo de checagem de status da aula: ${interval}ms. Próxima checagem às: ${nextCheckTime}`);
        this.statusCheckInterval = setTimeout(async () => {
            await this.checkAulaStatus(); // Aguarda a execução de checkAulaStatus
        }, interval);
    };

    scheduleNextCheck();
 },

      async isValidTimeMa (item)
      {
        if (this.$store.getters.getCfc.uf == "MA" && !this.isCurrentClass(item.id)) {
          let response = await aulaTeorico.getTimeFromBegin(item.id)
            .catch(err => {
              console.info("Não foi possível buscar as informações nescessárias para determinar se o aluno está realizando a entrada de aula no tempo correto.");
              alert("Não foi possível verificar o status da aula para permitir a entrada, verifique a sua conexão com a internet.");
              return false;
            });

          let timeFromBegin = parseInt(response.data.message)
          let duracao = item.tempo_aula_teorico;
          let lostClasses = 0;

          if(timeFromBegin < 0) {
            alert("Não é possível entrar nesta aula no momento.")
            return false;
          }

          if (timeFromBegin > duracao) {
            lostClasses = Math.floor(timeFromBegin / duracao);
            alert(`Atenção, você perdeu ${lostClasses} aulas e está entrando na ${lostClasses + 1}ª aula.`);
          }

          timeFromBegin = timeFromBegin - (duracao * lostClasses);
          if (timeFromBegin > 15) {
            alert(`Atenção: O tempo de 15 minutos de atraso foi ultrapassado, você não terá presença na aula atual, a próxima aula inicia em ${duracao - timeFromBegin} minutos`);
            return false;
          }

          return true;
        } else {
          return true;
        }

        return false;
      },

      async showImageModal(item)
      {
        this.tempObjMeet = item;

        if (!this.permissaoBiometria && !this.imagePermission) {
            alert("Você deve permitir a coleta de imagem para iniciar a aula.");
            console.log("Permissão de coleta de imagem negada.");
            return;
       }
        if ((this.tempObjMeet.status == '4' || this.tempObjMeet.status == '5' || this.tempObjMeet.status =='8' || this.isCurrentClass(item.id)) && await this.isValidTimeMa(item)) {
          this.loading = true;
          let response = await aulaTeorico.getNumeroBiometriasTiradas(this.tempObjMeet.id, this.$store.getters.getAluno.id, '0')
            .catch(erro => {
              console.error('Erro ao buscar biometrias: ', erro);
              alert("Houve um erro ao buscar as informações da chamada de video da aula, verifique sua conexão com a internet.");
              this.verificarSeFinalAula();
            })

          this.loading = false;

          if (response.data.biometrias > 0) {
            this.$router.push({ hash: '#aula' });
            this.toLiveStream(item['link_meet']);
            this.startTracking();
            await this.logVisibilityAction('entrou_na_aula'); 
            this.refreshComponent();
          } else {
            this.verificarSeFinalAula();
          }
        }
      },

      verificarSeFinalAula() {
        if(!this.closedAula) {
          this.showModalCheck = true;
        } else {
          this.abrirModalBiometria(this.MOMENTO_FINAL);
        }
      },

      abrirModalBiometria(momento = this.MOMENTO_INICIAL)
      {
        this.setMomento(momento);
        this.disableInteraction = false;
        this.showModalCheck = false;
        this.choosedGesture = Math.floor(Math.random() * this.gestures.length);
        this.choosedGesture = this.gestures[this.choosedGesture];
        this.showModal = true;
      },

      capturarFotoAleatoria(momento = this.MOMENTO_ALEATORIO) {
        this.setMomento(momento);
        this.showModalCheck = false;
        this.choosedGesture = Math.floor(Math.random() * this.gestures.length);
        this.choosedGesture = this.gestures[this.choosedGesture];
        this.disableInteraction = true;
        this.showModal = true;

        // Desligar a câmera do Jitsi Meet antes de capturar a foto
        if (this.apiMeet) {
          this.apiMeet.executeCommand('toggleVideo'); // Desliga a câmera
        }

        // Aguarda 1 segundo antes de capturar a foto
        setTimeout(() => {
          // Dispara o evento de captura da foto
          document.dispatchEvent(new CustomEvent('onCapture'));
          // Reabilitar a câmera do Jitsi Meet após a captura
            setTimeout(() => {
              this.apiMeet.executeCommand('toggleVideo'); // Religa a câmera
            }, 1000); // Aguarda 1 segundo antes de religar a câmera
        }, 1000); // Aguarda 1 segundo antes de capturar a foto
      },
      fecharModalBiometria()
      {
        this.showModal = false;
        this.setMomento(this.MOMENTO_INICIAL)
      },
      async registrarAlertaTentativas(mensagem = null, idAlerta = 14) {
        try {
          const idAluno = this.$store.getters.getAluno.id;
          const idAula = this.tempObjMeet.id;
          const texto = mensagem;

          const res = await aulaTeorico.setAlertaMensagem(idAluno, idAula, texto, idAlerta);
          if (res && res.data && res.data.message) {
          console.log(res.data.message);
          }
        } catch (e) {
          console.error(e);
        }
      },

      async closeLive() {
        this.stopTracking();
        this.getAulaTeorico();
        this.setMomento(this.MOMENTO_FINAL);
        this.disableInteraction = false;
        const response = await aulaTeorico.getTempoRestante(this.tempObjMeet.id); 
        let answer = window.confirm("Ao sair manualmente da sala, não será possivel retornar, tem certeza?",'sim', 'nao');
        if(answer) {
          if(response.data.message >=15){ //definir qual a tolerancia, vai ser padronizado?
            await this.registrarAlertaTentativas(`Saiu antes de terminar a aula, faltando ${response.data.message} minutos`);
          }
          this.setCurrentClass(0);
          clearTimeout(window.randomBio);
          this.live = !this.live;
          this.closedAula = true;
          this.abrirModalBiometria(this.MOMENTO_FINAL);
        }
      },

      async toLiveStream()
      {
        this.showModalCheck = false;

        if(this.setCurrentClass(this.tempObjMeet.id)){
          const response = await aulaTeorico.getJitsiParameters(this.tempObjMeet.id,this.$store.getters.getAluno.cpf)
            .catch(err => {
              console.error("Falha ao obter dados da chamada jitsi: ", err)
              alert("Não foi possível obter informações da chamada, favor verificar sua conexão com a internet.")
            });
          this.jitsiJWT = response.data.jwt
          this.jitsiDomain = response.data.domain
          this.jitsiExternalScript = response.data.externalApiJs
          this.linkMeet = response.data.roomName
          this.live = true;
        }
      },

      getAulaTeorico()
      {
        this.loading = true;

        if (!this.$store.getters.getAluno.cpf) {
          this.$router.push("/login", () => {});
        }

        aulaTeorico.findAll(this.$store.getters.getAluno.cpf).then(response => {
          var aulas = response.data;
          aulas.map((aula) => {
            if (aula.status == 4 || aula.status == 5) {
              aulaTeorico.getNumeroBiometriasTiradas(aula.id, this.$store.getters.getAluno.id, '2')
                .then(response => {
                  if (response.data.biometrias > 0) {
                    aula.status = 2;
                  }
                });
            }
            return aula;
          });
          this.agendaAulas = aulas;
          this.loading = false;
        });

      },

      async setCurrentClass(idAula)
      {
        var response = "";
        try {
          response = await aluno.setClass(this.$store.getters.getAluno.cpf, idAula);
          return(response.data.status);
        } catch (e) {
          console.log(e);
          return false;
        }
      },

      async setMomento(momento)
      {
        window.momento = momento;
      },

      async checkPermissaoBiometria() {
      try {
        const response = await Api.get('/alunos/permissao/biometria', {
          params: { cpf: this.$store.getters.getAluno.cpf }
        });
        this.permissaoBiometria = response.data.permissao_biometria === 1;
      } catch (error) {
        console.error('Erro ao verificar permissão de biometria:', error);
      }
    },
    async handlePermissionChange() {
      if (this.imagePermission) {
        try {
          const response = await Api.put('/alunos/permissao/biometria', {
            cpf: this.$store.getters.getAluno.cpf
          });
          this.permissaoBiometria = true;
        } catch (error) {
          console.error('Erro ao atualizar permissão de biometria:', error);
        }
      } else {
        alert("Você deve permitir a coleta de imagem para iniciar a aula.");
      }
    },

      update(){
        this.getAulaTeorico();
      },
    },
};
</script>
<style>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
</style>
